import { Component } from "@opten/compiler/metadata/component";
import { Select, SelectOptions } from "@opten/select";

@Component({ className: 'js-select' })
export class SelectComponent {
	select: Select
    constructor(private element: HTMLSelectElement) {
        this.select = new Select(element, {
			classes: {
				component: 'c-select',
				active: '--active',
				highlighted: '--highlighted',
				disabled: '--disabled',
				iconHtml: ''
			}
		} as SelectOptions);
    }
}